import { apiClient } from './client';
import { ApiResponse, AuthResponse, User } from '../types';

export const authApi = {
  login: async (email: string, password: string): Promise<ApiResponse<AuthResponse>> => {
    return apiClient.post('/auth/login', { email, password });
  },

  register: async (data: {
    email: string;
    phone: string;
    password: string;
    first_name: string;
    last_name: string;
    middle_name?: string;
    date_of_birth?: string;
  }): Promise<ApiResponse<AuthResponse>> => {
    return apiClient.post('/auth/register', data);
  },

  getProfile: async (): Promise<ApiResponse<{ user: User }>> => {
    return apiClient.get('/auth/profile');
  },
};
